import type { LoginRequestDto, LoginResponseDto } from '@/dtos/auth.dto'
import { API_ENDPOINTS } from '@/constants'
import { apiClient } from '@/config/axios'

export async function login(dto: LoginRequestDto): Promise<LoginResponseDto> {
  const { data } = await apiClient.post<LoginResponseDto>(API_ENDPOINTS.AUTH.LOGIN, dto)
  return data
}

export async function refreshAccessToken(refreshToken: string): Promise<LoginResponseDto> {
  const { data } = await apiClient.post<LoginResponseDto>(API_ENDPOINTS.AUTH.REFRESH, {
    refreshToken,
  })
  return data
}
